import { ClientInformation } from 'src/app/models/client-information';
import { CurrentStatus } from 'src/app/models/currentStatus';
import { DestinationEndpoint } from 'src/app/models/destination-endpoint';
import { ErrorCategory } from 'src/app/models/error-category';
import { ImportType } from 'src/app/models/import-type';
import { Integration } from 'src/app/models/integration';
import { EnrichedIntegrationError } from 'src/app/models/integration-error';

export class LTHelperUtils {
    
  //#region DestinationEndpoint
  static getEndpointName(dests: DestinationEndpoint[], destId: number): string {
    let endpointName = '';
    if (!dests || dests.length === 0 || !destId) {
        endpointName = dests.find(d => d.destinationEndpointId == destId).endpointName;
    }
    return endpointName;
  }
  
  static getDestinationEndpoint(items: DestinationEndpoint[], id: number): DestinationEndpoint | null {
    if (!items || items.length === 0 || !id)
      return null;
  
    const dest = items.find(x => x.destinationEndpointId == id);
    if (dest != null)
      return dest;
    
    return null;
  }
  //#endregion
  
  //#region ImportType

  static getImportType(items: ImportType[], id: number): ImportType | null {
    if (!items || items.length === 0 || !id)
      return null;
  
    const importType = items.find(x => x.importTypeId == id);
    if (importType != null)
      return importType;
  
    return null;
  }
  //#endregion
  
  //#region ErrorCategory
  
  static getErrorCategory(items: ErrorCategory[], id: number): ErrorCategory | null {
    if (!items || items.length === 0 || !id)
      return null;
  
    const cat = items.find(x => x.errorCategoryId == id);
    if (cat != null)
      return cat;
    
    return null;
  }
  //#endregion
  
  //#region CurrentStatus
  
  static getCurrentStatus(items: CurrentStatus[], id: number): CurrentStatus | null {
    if (!items || items.length === 0 || !id)
      return null;
  
    const status = items.find(x => x.currentStatusId == id);
    if (status != null)
      return status;
    
    return null;
  }
  
  static getCurrentStatusByName(items: CurrentStatus[], name: string): CurrentStatus | null {
    if (!items || items.length === 0 || !name)
      return null;
  
    const status = items.find(x => x.statusName == name);
    if (status != null)
      return status;
    
    return null;
  }
  //#endregion
  
  //#region ClientInformation
  
  static getClientByLosTalkerClientId(items: ClientInformation[], id: number): ClientInformation | null {
    if (!items || items.length === 0 || !id)
      return null;
  
    const client = items.find(x => x.losTalkerClientId == id);
    if (client != null)
      return client;
    
    return null;
  }
  //#endregion
  
  //#region Integration
  
  static getIntegration(items: Map<string, Integration>, id: string): Integration | null {
    if (!items || items.size === 0 || !id)
      return null;
  
    return items.get(id);
  }
  
  static getIntegrationDisplayName(item: EnrichedIntegrationError, defaultName = 'Not Populated, likely Deleted'): string {
    if (item === null || item === undefined)
      return defaultName;
  
    if (item.integration?.name) {
      return item.integration.name;
    }

    if (item.integrationName) {
      return item.integrationName;
    }

    return defaultName;
  }
  //#endregion
    
    
}